import React, { Component }  from 'react';

class TextToSpeech extends Component {
	constructor(props) {
		super(props);
		this.state = { 	
			loading: false,
		};
	}
	
	toggleVoice = (voice) => (e) => {
		this.props.ws.send(JSON.stringify({route: 'toggleVoice', voice: voice }))	
	}
	
	render() {
		if (this.props.active) {	
			var pjList = []
			for (var voice of this.props.data.TextToSpeech) {
				pjList.push(
					<div className="dataRow" key={voice.voice}>
						<div className="activeBox" onClick={this.toggleVoice(voice)}>
							<div className={voice.active ? "enabled" : "disabled"}></div>
						</div>
						<span style={{flex: '0 0 150px'}} >{voice.provider}</span>
						<span style={{flex: '1 0 20%'}} >{voice.voice}</span>
					</div>
				)
			}
			
		
			return (
				<div width="100%">
					{pjList}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default TextToSpeech


// WEBPACK FOOTER //
// ./src/Views/TextToSpeech.js